import script from "./MainBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainBanner.vue?vue&type=script&setup=true&lang=ts"

import "./MainBanner.vue?vue&type=style&index=0&id=793f91fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-793f91fa"]])

export default __exports__